module.exports = __webpack_public_path__ + "static/chihuahuaRescueMidwestImage-88a0fe34ebf2caf8dbedfe8e130e3cb3.png";